// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rx-0";